'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'bell-ring';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e62c';
var svgPathData = ['M48 379.2c0 11.5 9.3 20.8 20.8 20.8l374.3 0c11.5 0 20.8-9.3 20.8-20.8 0-4.1-1.2-8.1-3.5-11.6L437.4 333C413 296.4 400 253.4 400 209.4l0-17.4c0-79.5-64.5-144-144-144S112 112.5 112 192l0 17.4c0 44-13 87-37.4 123.6L51.5 367.6C49.2 371 48 375 48 379.2z', 'M248 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24.2c84.6 4.2 152 74.1 152 159.8l0 17.4c0 40.8 12.1 80.8 34.8 114.8l23.1 34.6c4 6.1 6.2 13.2 6.2 20.4 0 20.3-16.5 36.8-36.8 36.8L68.8 416c-20.3 0-36.8-16.5-36.8-36.8 0-7.3 2.2-14.4 6.2-20.4l23.1-34.6C83.9 290.1 96 250.2 96 209.4L96 192c0-85.7 67.4-155.6 152-159.8L248 8zM112 209.4c0 44-13 87-37.4 123.6L51.5 367.6C49.2 371 48 375 48 379.2 48 390.7 57.3 400 68.8 400l374.3 0c11.5 0 20.8-9.3 20.8-20.8 0-4.1-1.2-8.1-3.5-11.6L437.4 333C413 296.4 400 253.4 400 209.4l0-17.4c0-79.5-64.5-144-144-144S112 112.5 112 192l0 17.4zM256 512c-31.3 0-58-20-67.9-48l17.3 0c9 18.9 28.3 32 50.6 32s41.6-13.1 50.6-32l17.3 0c-9.9 28-36.6 48-67.9 48zM101.5 29.8c-42.8 40.8-69.5 98.4-69.5 162.2 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-68.4 28.6-130.1 74.5-173.8 3.2-3 8.3-2.9 11.3 .3s2.9 8.3-.3 11.3zm320-11.6c45.9 43.7 74.5 105.4 74.5 173.8 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-63.8-26.7-121.4-69.5-162.2-3.2-3-3.3-8.1-.3-11.3s8.1-3.3 11.3-.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBellRing = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;